import React from "react";
import HeaderImage from "../../assets/about-Us-header.png";
import { aboutUs } from "./data";
import desertShape from "../../assets/icons/Group.svg";
import "./aboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="desert-shape shape">
        <img src={desertShape} alt="desertShape" />
      </div>
      <div className="square-shape shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="261"
          height="287"
          viewBox="0 0 261 287"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M124.167 1.68317C128.105 -0.505067 132.894 -0.505067 136.833 1.68317L254.194 66.8834C254.293 66.9382 254.391 66.9943 254.488 67.0518C258.471 69.3951 260.917 73.6711 260.917 78.292V208.709C260.917 213.445 258.349 217.809 254.208 220.11L136.833 285.318C132.836 287.539 127.969 287.501 124.008 285.228L6.79136 220.107C2.65103 217.808 0.083252 213.444 0.083252 208.707V78.292C0.083252 73.6711 2.52844 69.3937 6.5111 67.0503L6.69929 67.048L6.79136 66.8915L124.167 1.68317ZM130.501 128.581L39.9807 78.2914L130.5 28.0028L221.021 78.292L130.501 128.581ZM26.1666 100.456V201.034L117.458 251.751V151.174L26.1666 100.456ZM143.542 151.174V251.753L234.833 201.035V100.456L143.542 151.174Z"
            fill="#0D9AE1"
            fillOpacity="0.16"
          />
        </svg>
      </div>
      <div className="sun-shape shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="189"
          height="260"
          viewBox="0 0 189 260"
          fill="none"
        >
          <g opacity="0.5" clipPath="url(#clip0_30388_5706)">
            <path
              d="M142.833 35.763C142.833 35.763 145.881 24.3865 157.258 27.4348C168.634 30.4831 165.586 41.8596 165.586 41.8596L162.538 53.2361C162.538 53.2361 159.489 64.6125 148.113 61.5642C136.736 58.5159 139.785 47.1394 139.785 47.1394L142.833 35.763ZM223.883 142.833C223.883 142.833 235.259 145.881 232.211 157.258C229.163 168.634 217.786 165.586 217.786 165.586L206.41 162.538C206.41 162.538 195.033 159.489 198.082 148.113C201.13 136.736 212.506 139.785 212.506 139.785L223.883 142.833ZM53.236 97.1083C53.236 97.1083 64.6125 100.157 61.5642 111.533C58.5159 122.91 47.1394 119.861 47.1394 119.861L35.763 116.813C35.763 116.813 24.3865 113.765 27.4348 102.388C30.4831 91.0117 41.8596 94.06 41.8596 94.06L53.236 97.1083ZM95.6363 55.3861C95.6363 55.3861 101.524 65.5844 91.326 71.4724C81.1277 77.3604 75.2397 67.1621 75.2397 67.1621L69.3445 56.9679C69.3445 56.9679 63.4565 46.7696 73.6563 40.8759C83.8603 34.9895 89.7483 45.1878 89.7483 45.1878L95.6363 55.3861ZM208.43 102.85C208.43 102.85 198.231 108.738 192.343 98.5399C186.455 88.3416 196.654 82.4536 196.654 82.4536L206.852 76.5656C206.852 76.5656 217.05 70.6776 222.938 80.8759C228.826 91.0742 218.628 96.9622 218.628 96.9622L208.43 102.85ZM56.9695 190.296C56.9695 190.296 46.7711 196.184 40.8831 185.985C34.9951 175.787 45.1935 169.899 45.1935 169.899L55.3918 164.011C55.3918 164.011 65.5901 158.123 71.4781 168.321C77.3661 178.52 67.1678 184.408 67.1678 184.408L56.9695 190.296Z"
              fill="#FFCB45"
            />
            <path
              d="M114.581 186.705C145.997 195.123 178.287 176.48 186.705 145.065C195.123 113.649 176.48 81.3585 145.064 72.9408C113.649 64.5231 81.3582 83.1663 72.9406 114.582C64.5229 145.997 83.1661 178.288 114.581 186.705Z"
              fill="#FFCB45"
            />
            <path
              d="M188.888 177.352C185.236 176.373 181.568 176 177.97 176.164C177.148 163.58 168.72 152.439 156.166 149.075C142.696 145.466 128.865 151.99 122.299 164.003C119.618 160.397 115.805 157.795 111.47 156.614C100.474 153.668 89.1053 160.443 86.0738 171.757C85.3376 174.504 85.1856 177.256 85.498 179.912C83.7352 178.806 81.8235 177.957 79.8209 177.391C67.6025 174.117 54.9696 181.651 51.6027 194.217C48.2358 206.782 55.4093 219.623 67.6276 222.897L169.384 250.163C188.929 255.4 209.142 243.355 214.531 223.241C219.919 203.134 208.438 182.59 188.888 177.352Z"
              fill="#F1F1F1"
            />
          </g>
          <defs>
            <clipPath id="clip0_30388_5706">
              <rect
                width="212"
                height="212"
                fill="white"
                transform="translate(54.8696) rotate(15)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="electric-shape shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="129"
          height="191"
          viewBox="0 0 129 191"
          fill="none"
        >
          <g opacity="0.3">
            <path
              d="M49.0485 12.0692L35.583 82.8347L84.3715 82.9959L17.9573 178.926L31.4287 101.075L-17.3598 100.902L49.0485 12.0692ZM49.0545 0.137695C48.7321 0.137695 48.4098 0.149633 48.0935 0.173508C45.9865 0.340633 44.5898 1.05091 42.9365 2.1611C42.0173 2.76991 41.1757 3.52198 40.4356 4.38745C40.2147 4.6441 40.0118 4.9127 39.8208 5.18726L-27.071 93.7158C-29.7092 97.3388 -30.1031 102.114 -28.0737 106.107C-26.0444 110.1 -21.9498 112.631 -17.4553 112.667L17.0023 112.917L6.16897 176.747C5.14235 182.232 8.06703 187.7 13.2121 189.902C14.7461 190.559 16.3576 190.875 17.9453 190.875C21.6997 190.875 24.7795 189.12 27.0954 185.951L94.0648 90.0211C96.703 86.3981 97.091 81.6171 95.0675 77.63C93.0382 73.6369 88.9436 71.1061 84.4491 71.0763L49.9915 71.0166L60.7114 14.8984C60.9382 13.9971 61.0516 13.06 61.0516 12.0931C61.0516 5.63491 55.9125 0.370477 49.4782 0.16157C49.335 0.155602 49.1977 0.155602 49.0545 0.155602V0.137695Z"
              fill="#FFCB45"
            />
          </g>
        </svg>
      </div>
      <div className="cold-shape shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="192"
          height="242"
          viewBox="0 0 192 242"
          fill="none"
        >
          <g clipPath="url(#clip0_30388_5793)">
            <path
              d="M140.391 181.352L123.943 164.96L143.446 159.578C147.043 158.585 149.146 154.873 148.143 151.286C147.139 147.699 143.411 145.598 139.812 146.589L112.948 154.003L101.391 142.486L107.968 117.943L123.725 113.75L143.293 133.604C144.171 134.495 145.235 135.091 146.363 135.393C148.6 135.992 151.085 135.431 152.856 133.698C155.518 131.094 155.552 126.827 152.933 124.169L138.73 109.757L161.176 103.783C164.782 102.824 166.919 99.1308 165.949 95.5351C164.98 91.9398 161.268 89.8023 157.663 90.7622L135.22 96.7346L140.265 77.1993C141.196 73.5969 139.018 69.8952 135.402 68.9848C131.784 68.0498 128.098 70.2129 127.168 73.8153L120.216 100.726L104.453 104.921L86.4028 86.9312L90.611 71.226L117.614 64.3042C121.228 63.3774 123.4 59.7048 122.463 56.0995C121.526 52.4951 117.835 50.3231 114.221 51.2508L94.6167 56.2765L100.61 33.9078C101.573 30.3141 99.4297 26.617 95.8207 25.6499C92.2118 24.6829 88.5068 26.8129 87.5438 30.4067L81.5502 52.7754L67.0844 38.6216C64.4166 36.0097 60.1345 36.0461 57.5217 38.6994C54.9081 41.3524 54.9514 45.6194 57.6188 48.2294L77.5442 67.7257L73.3356 83.4327L48.7102 89.9855L37.1545 78.4695L44.5898 51.6895C45.5849 48.1044 43.4744 44.3883 39.8741 43.3891C39.8532 43.3835 39.834 43.3784 39.8149 43.3733C36.2346 42.4139 32.5445 44.5061 31.5544 48.0721L26.1571 67.5113L9.70953 51.1192C7.06399 48.4835 2.78317 48.4803 0.146948 51.1096C-2.49102 53.7384 -2.48684 58.0052 0.156316 60.6393L16.6084 77.0355L-2.9006 82.414C-6.49847 83.4056 -8.6023 87.1177 -7.59924 90.7054C-6.93313 93.0906 -5.06138 94.8197 -2.82353 95.4193C-1.69633 95.7213 -0.475564 95.7369 0.72907 95.405L27.6045 87.9951L39.1557 99.5071L32.5796 124.049L16.8119 128.246L-2.74942 108.39C-5.36748 105.732 -9.64789 105.689 -12.3119 108.293C-14.9742 110.898 -15.0083 115.165 -12.3903 117.823L1.81096 132.236L-20.628 138.207C-24.2341 139.167 -26.3711 142.86 -25.401 146.456C-24.7495 148.868 -22.867 150.623 -20.6091 151.228C-19.5011 151.525 -18.3009 151.544 -17.1147 151.229L5.32511 145.257L0.27925 164.793C-0.646122 168.375 1.50248 172.033 5.08357 172.992C5.10274 172.997 5.12364 173.003 5.14304 173.007C8.75973 173.942 12.4464 171.779 13.3771 168.177L20.3279 141.264L36.0933 137.069L54.1435 155.058L49.9344 170.767L22.9303 177.689C19.3162 178.615 17.1445 182.288 18.0812 185.893C18.7152 188.332 20.6099 190.115 22.8887 190.725C23.9776 191.017 25.1549 191.042 26.3238 190.742L45.9285 185.717L39.9353 208.084C38.9723 211.678 41.1159 215.375 44.7249 216.342C48.3339 217.309 52.0388 215.179 53.0018 211.585L58.995 189.219L73.4608 203.372C74.3233 204.216 75.3551 204.784 76.4439 205.076C78.7227 205.686 81.2549 205.09 83.0234 203.294C85.6373 200.641 85.5938 196.374 82.9264 193.765L63.0018 174.268L67.2107 158.561L91.8385 152.006L103.393 163.519L95.9502 190.299C94.9542 193.884 97.0644 197.601 100.664 198.601C100.683 198.607 100.704 198.613 100.724 198.618C104.305 199.577 107.994 197.485 108.984 193.921L114.389 174.477L130.839 190.872C131.71 191.74 132.758 192.322 133.866 192.618C136.124 193.223 138.633 192.644 140.402 190.882C143.039 188.253 143.034 183.986 140.391 181.352ZM52.2224 103.007L76.8511 96.4527L94.901 114.443L88.3252 138.984L63.6983 145.54L45.6466 127.549L52.2224 103.007Z"
              fill="#0D9AE1"
              fillOpacity="0.16"
            />
          </g>
          <defs>
            <clipPath id="clip0_30388_5793">
              <rect
                width="198.205"
                height="197.418"
                fill="white"
                transform="translate(0.0957031) rotate(15)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="about-us-container container">
        <div className="about-us-header">
          <h1>خبرتنا بين يديك</h1>
          <p>
            نقدم خدمات صيانة مبتكرة تناسب البيئة الصحراوية، ونسعى دائمًا لتحقيق
            أعلى درجات رضا العملاء.
          </p>
          <div className="circles-shape shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="144"
              height="135"
              viewBox="0 0 144 135"
              fill="none"
            >
              <circle cx="8" cy="8" r="8" fill="#FFA12F" fillOpacity="0.16" />
              <circle cx="40" cy="8" r="8" fill="#FFA12F" fillOpacity="0.16" />
              <circle cx="72" cy="8" r="8" fill="#FFA12F" fillOpacity="0.16" />
              <circle cx="104" cy="8" r="8" fill="#FFA12F" fillOpacity="0.16" />
              <circle cx="136" cy="8" r="8" fill="#FFA12F" fillOpacity="0.16" />
              <circle
                cx="8"
                cy="37.6001"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="37.6001"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="37.6001"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="37.6001"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="37.6001"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="8"
                cy="67.2002"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="67.2002"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="67.2002"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="67.2002"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="67.2002"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="8"
                cy="96.7998"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="96.7998"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="96.7998"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="96.7998"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="96.7998"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="8"
                cy="126.4"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="126.4"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="126.4"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="126.4"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="126.4"
                r="8"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
            </svg>
          </div>
          <div className="blue-circles-shape shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="144"
              height="135"
              viewBox="0 0 144 135"
              fill="none"
            >
              <circle cx="8" cy="8" r="8" fill="#0D9AE1" fillOpacity="0.16" />
              <circle cx="40" cy="8" r="8" fill="#0D9AE1" fillOpacity="0.16" />
              <circle cx="72" cy="8" r="8" fill="#0D9AE1" fillOpacity="0.16" />
              <circle cx="104" cy="8" r="8" fill="#0D9AE1" fillOpacity="0.16" />
              <circle cx="136" cy="8" r="8" fill="#0D9AE1" fillOpacity="0.16" />
              <circle
                cx="8"
                cy="37.5996"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="37.5996"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="37.5996"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="37.5996"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="37.5996"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="8"
                cy="67.2002"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="67.2002"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="67.2002"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="67.2002"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="67.2002"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="8"
                cy="96.7998"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="96.7998"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="96.7998"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="96.7998"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="96.7998"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="8"
                cy="126.4"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="40"
                cy="126.4"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="72"
                cy="126.4"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="104"
                cy="126.4"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
              <circle
                cx="136"
                cy="126.4"
                r="8"
                fill="#0D9AE1"
                fillOpacity="0.16"
              />
            </svg>
          </div>
          <div className="shape0 shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
            >
              <g opacity="0.3" clipPath="url(#clip0_30388_5801)">
                <path
                  d="M42.6663 27.32L38.1502 26.1625L41.0271 23.296C41.5577 22.7673 41.5552 21.9233 41.0215 21.4109C40.4876 20.8985 39.6252 20.9118 39.0941 21.4403L35.1315 25.3887L31.9586 24.5756L30.6595 19.7271L32.9993 17.4376L38.4069 18.875C38.6496 18.9395 38.8954 18.935 39.123 18.874C39.5745 18.7531 39.9535 18.409 40.0905 17.9364C40.2965 17.2257 39.8765 16.4935 39.1526 16.301L35.2273 15.2575L38.5603 11.9963C39.0958 11.4723 39.1011 10.6282 38.5723 10.111C38.0437 9.59364 37.1805 9.59915 36.6452 10.123L33.3127 13.3838L32.2456 9.54346C32.0488 8.83525 31.298 8.42046 30.574 8.62604C29.8473 8.82754 29.4181 9.56497 29.6148 10.2732L31.0847 15.5635L28.744 17.8538L23.788 16.5833L22.9567 13.4808L26.9928 9.60251C27.533 9.08338 27.5465 8.23929 27.0225 7.71704C26.4986 7.19496 25.6356 7.19254 25.0955 7.71184L22.1654 10.5275L20.9813 6.10856C20.7911 5.39861 20.0467 4.98117 19.3184 5.17632C18.5901 5.37148 18.1541 6.10518 18.3444 6.81513L19.5284 11.2341L15.5829 10.2609C14.8551 10.0812 14.1091 10.5149 13.9167 11.2289C13.724 11.943 14.1576 12.6675 14.8851 12.8469L20.3198 14.1875L21.1512 17.2904L17.4945 20.8682L14.3219 20.0551L12.9497 14.7388C12.766 14.0271 12.0255 13.6031 11.2955 13.7919C11.2913 13.793 11.2874 13.794 11.2835 13.7951C10.561 13.9887 10.1239 14.7144 10.3066 15.4224L11.3026 19.2814L6.78669 18.1238C6.06041 17.9378 5.31069 18.3646 5.11171 19.0769C4.91237 19.7893 5.3391 20.5176 6.0648 20.7036L10.5819 21.8615L7.70365 24.7279C7.17281 25.2565 7.17514 26.1005 7.70893 26.6132C8.06368 26.954 8.56397 27.0625 9.0156 26.9415C9.24308 26.8805 9.45834 26.7613 9.63609 26.5843L13.6011 22.6355L16.7726 23.4484L18.0717 28.2967L15.7304 30.5878L10.3236 29.1495C9.59991 28.9569 8.84628 29.3769 8.63992 30.0877C8.43391 30.7983 8.85393 31.5305 9.57763 31.7231L13.5027 32.7669L10.1707 36.0272C9.63527 36.5511 9.62989 37.3953 10.1587 37.9125C10.5136 38.2594 11.0183 38.3713 11.474 38.2492C11.6976 38.1893 11.9097 38.0727 12.0858 37.9004L15.4179 34.6401L16.485 38.4805C16.6807 39.1848 17.422 39.595 18.1447 39.4013C18.1486 39.4003 18.1528 39.3991 18.1566 39.3979C18.8831 39.1965 19.3125 38.459 19.1158 37.7508L17.6456 32.4602L19.9867 30.1696L24.9426 31.4401L25.7741 34.5433L21.7378 38.4216C21.1977 38.9408 21.1842 39.7848 21.7081 40.3071C22.0626 40.6604 22.5723 40.7757 23.0322 40.6524C23.2519 40.5936 23.4605 40.4802 23.6352 40.3123L26.5655 37.4968L27.7494 41.9154C27.9397 42.6253 28.684 43.0428 29.4124 42.8476C30.1407 42.6524 30.5766 41.9187 30.3864 41.2088L29.2025 36.7902L33.1479 37.7634C33.3832 37.8214 33.6205 37.8153 33.8402 37.7564C34.3001 37.6332 34.6838 37.2785 34.8142 36.7953C35.0068 36.0811 34.5733 35.3568 33.8457 35.1773L28.4113 33.8367L27.5798 30.7336L31.2367 27.1552L34.4089 27.9681L35.7797 33.2852C35.9633 33.9969 36.7038 34.4211 37.4337 34.2325C37.4378 34.2316 37.442 34.2304 37.446 34.2293C38.1686 34.0357 38.6055 33.31 38.4231 32.6024L37.4278 28.7419L41.9445 29.8996C42.1836 29.9609 42.4251 29.9557 42.6487 29.8958C43.1044 29.7737 43.4858 29.4242 43.6195 28.9465C43.8187 28.2344 43.3918 27.5061 42.6663 27.32ZM19.4095 22.7417L23.0665 19.1632L28.0225 20.4338L29.3216 25.282L25.6649 28.8603L20.7085 27.5898L19.4095 22.7417Z"
                  fill="#0D9AE1"
                />
              </g>
              <defs>
                <clipPath id="clip0_30388_5801">
                  <rect
                    width="40"
                    height="39"
                    fill="white"
                    transform="translate(0 10.3525) rotate(-15)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="shape-1 shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="242"
              height="242"
              viewBox="0 0 242 242"
              fill="none"
            >
              <path
                d="M108.052 118.325C97.5071 112.192 83.083 104.45 64.9846 98.9766C46.6814 93.4403 26.6881 90.7495 3.8616 90.7495C1.7285 90.7495 0 92.478 0 94.6111C0 96.7442 1.7285 98.4727 3.8616 98.4727C49.2593 98.4727 76.7934 109.077 104.169 125.001C104.78 125.356 105.447 125.525 106.107 125.525C107.437 125.525 108.732 124.837 109.448 123.604C110.52 121.761 109.895 119.397 108.052 118.325Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M238.138 90.7495C178.476 90.7495 148.228 109.364 118.976 127.365C89.3349 145.606 61.3375 162.835 3.8616 162.835C1.7285 162.835 0 164.563 0 166.696C0 168.829 1.7285 170.558 3.8616 170.558C63.5241 170.558 93.7717 151.944 123.024 133.943C152.665 115.702 180.662 98.4727 238.138 98.4727C240.271 98.4727 242 96.7442 242 94.6111C242 92.478 240.271 90.7495 238.138 90.7495Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M121 25.1011C106.095 25.1011 93.9683 37.228 93.9683 52.1332C93.9683 67.0384 106.095 79.1649 121 79.1649C135.905 79.1649 148.032 67.038 148.032 52.1332C148.032 37.228 135.905 25.1011 121 25.1011ZM121 71.4412C110.353 71.4412 101.691 62.7798 101.691 52.1328C101.691 41.4857 110.353 32.8243 121 32.8243C131.647 32.8243 140.308 41.4857 140.308 52.1328C140.308 62.7798 131.647 71.4412 121 71.4412Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M121 9.6543C100.878 9.6543 83.3708 23.9484 79.3726 43.6416C78.9477 45.7312 80.298 47.7693 82.3881 48.1937C84.4777 48.6182 86.5163 47.2678 86.9408 45.1782C90.2115 29.0691 104.534 17.3775 120.999 17.3775C140.164 17.3775 155.755 32.9685 155.755 52.1329C155.755 58.976 153.763 65.6007 149.994 71.2925C148.817 73.0706 149.303 75.466 151.082 76.6443C151.738 77.0787 152.478 77.2872 153.21 77.2872C154.462 77.2872 155.69 76.6788 156.433 75.5572C161.042 68.5974 163.478 60.4979 163.478 52.1338C163.479 28.7104 144.423 9.6543 121 9.6543Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M145.511 82.2144C144.334 80.4357 141.937 79.9499 140.159 81.1268C134.468 84.8957 127.843 86.888 121 86.888C104.535 86.888 90.2121 75.1964 86.9413 59.0878C86.5173 56.9977 84.4778 55.6459 82.3886 56.0722C80.2981 56.4962 78.9482 58.5343 79.3731 60.6248C83.3708 80.3176 100.878 94.6117 121 94.6117C129.365 94.6117 137.464 92.1756 144.423 87.5662C146.202 86.3889 146.688 83.993 145.511 82.2144Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M23.1702 118.255C25.3029 118.255 27.0318 116.527 27.0318 114.394C27.0318 112.261 25.3029 110.532 23.1702 110.532C21.0375 110.532 19.3086 112.261 19.3086 114.394C19.3086 116.527 21.0375 118.255 23.1702 118.255Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M38.617 133.702C40.7497 133.702 42.4786 131.973 42.4786 129.841C42.4786 127.708 40.7497 125.979 38.617 125.979C36.4843 125.979 34.7554 127.708 34.7554 129.841C34.7554 131.973 36.4843 133.702 38.617 133.702Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M187.936 216.899C190.069 216.899 191.798 215.17 191.798 213.037C191.798 210.905 190.069 209.176 187.936 209.176C185.803 209.176 184.074 210.905 184.074 213.037C184.074 215.17 185.803 216.899 187.936 216.899Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M203.383 232.345C205.516 232.345 207.245 230.616 207.245 228.484C207.245 226.351 205.516 224.622 203.383 224.622C201.25 224.622 199.521 226.351 199.521 228.484C199.521 230.616 201.25 232.345 203.383 232.345Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M218.83 133.702C220.963 133.702 222.691 131.973 222.691 129.841C222.691 127.708 220.963 125.979 218.83 125.979C216.697 125.979 214.968 127.708 214.968 129.841C214.968 131.973 216.697 133.702 218.83 133.702Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
              <path
                d="M38.617 216.899C40.7497 216.899 42.4786 215.17 42.4786 213.037C42.4786 210.905 40.7497 209.176 38.617 209.176C36.4843 209.176 34.7554 210.905 34.7554 213.037C34.7554 215.17 36.4843 216.899 38.617 216.899Z"
                fill="#FFA12F"
                fillOpacity="0.16"
              />
            </svg>
          </div>
          <div className="about-image-box">
            <img src={HeaderImage} alt="HeaderImage" />
          </div>
        </div>
        <div className="about-us-content">
          {aboutUs.map((item, index) => (
            <div
              className={`about-us-box ${
                index % 2 === 0 ? "text-right" : "text-left"
              }`}
              key={item.id}
            >
              {index % 2 === 0 ? (
                <>
                  <div className="about-us-box-right">
                    <h1>{item.title}</h1>
                    <p>{item.contentText}</p>
                  </div>
                  <div className="content-shape shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="177"
                      height="176"
                      viewBox="0 0 177 176"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_30388_5799)">
                        <path
                          d="M139.817 131.86L127.775 119.952L142.013 116.084C144.639 115.37 146.169 112.683 145.43 110.081C144.691 107.48 141.964 105.951 139.337 106.663L119.726 111.993L111.266 103.627L116.029 85.8489L127.532 82.8351L141.858 97.2573C142.501 97.9044 143.279 98.338 144.104 98.5589C145.739 98.997 147.553 98.5941 148.844 97.3413C150.784 95.4578 150.802 92.3654 148.885 90.4344L138.486 79.9656L154.872 75.6728C157.505 74.9831 159.06 72.31 158.345 69.7023C157.631 67.0948 154.916 65.5395 152.285 66.2293L135.901 70.5214L139.555 56.3706C140.229 53.7611 138.632 51.0746 135.988 50.4088C133.344 49.7252 130.656 51.287 129.982 53.8965L124.948 73.3898L113.44 76.4045L100.226 63.3362L103.274 51.9601L122.988 46.9873C125.626 46.3214 127.207 43.6631 126.516 41.0485C125.826 38.4345 123.126 36.8542 120.488 37.5207L106.176 41.1313L110.518 24.9284C111.215 22.3252 109.643 19.642 107.005 18.9353C104.368 18.2285 101.665 19.7662 100.967 22.3694L96.6258 38.5723L86.036 28.2901C84.083 26.3927 80.9552 26.4121 79.051 28.3309C77.1462 30.2495 77.1849 33.3423 79.1375 35.2383L93.724 49.4017L90.6755 60.7791L72.6984 65.4883L64.2387 57.1227L69.6261 37.7249C70.3471 35.128 68.7994 32.4312 66.1679 31.7011C66.1526 31.697 66.1386 31.6933 66.1246 31.6895C63.5079 30.9884 60.8158 32.4987 60.0984 35.0817L56.1877 49.1624L44.1467 37.2545C42.2099 35.3399 39.083 35.3306 37.1616 37.232C35.239 39.133 35.249 42.2255 37.184 44.1391L49.2283 56.0498L34.9867 59.9162C32.3602 60.629 30.8295 63.3161 31.5681 65.9181C32.0585 67.648 33.4286 68.9043 35.0642 69.3425C35.8881 69.5633 36.7798 69.5766 37.6592 69.338L57.2784 64.0112L65.7348 72.3739L60.9714 90.1512L49.4607 93.1671L35.1396 78.744C33.2228 76.8132 30.0961 76.775 28.1544 78.6581C26.214 80.5416 26.1961 83.634 28.1128 85.5649L38.5097 96.0346L22.1288 100.326C19.4962 101.016 17.9413 103.689 18.6558 106.297C19.1356 108.046 20.5136 109.321 22.1638 109.763C22.9737 109.98 23.8504 109.996 24.7163 109.77L41.0979 105.478L37.444 119.629C36.7739 122.224 38.3494 124.879 40.9668 125.58C40.9808 125.584 40.9961 125.588 41.0102 125.591C43.6536 126.274 46.343 124.713 47.017 122.103L52.0502 102.608L63.5593 99.5934L76.7736 112.662L73.7247 124.04L54.0107 129.013C51.3722 129.679 49.7919 132.337 50.4821 134.952C50.9491 136.721 52.3361 138.016 54.0016 138.462C54.7975 138.675 55.6575 138.695 56.5108 138.48L70.8229 134.87L66.4817 151.071C65.7842 153.675 67.356 156.358 69.9938 157.065C72.6316 157.771 75.3344 156.234 76.0319 153.63L80.3732 137.429L90.9629 147.711C91.5943 148.324 92.3489 148.737 93.1448 148.95C94.8103 149.397 96.659 148.968 97.9479 147.67C99.8529 145.751 99.8141 142.659 97.8614 140.763L83.2755 126.6L86.3243 115.221L104.303 110.511L112.762 118.875L107.369 138.272C106.647 140.869 108.195 143.567 110.826 144.297C110.84 144.302 110.855 144.306 110.87 144.31C113.487 145.011 116.178 143.5 116.896 140.919L120.812 126.835L132.855 138.744C133.493 139.375 134.259 139.798 135.069 140.015C136.719 140.457 138.551 140.042 139.84 138.767C141.762 136.866 141.751 133.774 139.817 131.86ZM75.2852 74.9323L93.2646 70.2217L106.479 83.2906L101.716 101.067L83.7373 105.778L70.522 92.7089L75.2852 74.9323Z"
                          fill="#0D9AE1"
                          fillOpacity="0.16"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_30388_5799">
                          <rect
                            width="144.867"
                            height="143.001"
                            fill="white"
                            transform="translate(37.0405 0.188477) rotate(15)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="content-shape2 shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="63"
                      viewBox="0 0 64 63"
                      fill="none"
                    >
                      <g opacity="0.3" clipPath="url(#clip0_30388_5797)">
                        <path
                          d="M58.9136 44.3134L52.4135 40.619L58.0467 37.3492C59.0857 36.7461 59.4314 35.4281 58.8187 34.4053C58.2057 33.3826 56.8674 33.0429 55.8278 33.6454L48.0685 38.1495L43.5016 35.5542V27.4458L48.0659 24.8516L55.8281 29.3554C56.1764 29.5575 56.5581 29.6533 56.9352 29.6533C57.683 29.6533 58.4113 29.2749 58.8187 28.5947C59.4314 27.5719 59.0854 26.2539 58.0465 25.6508L52.412 22.3816L58.9136 18.6864C59.9582 18.0927 60.3161 16.7779 59.713 15.7496C59.1102 14.7214 57.7739 14.3691 56.7296 14.9628L50.2289 18.6574L50.1701 12.219C50.1593 11.0317 49.1707 10.0706 47.9666 10.0886C46.7602 10.0992 45.7913 11.0704 45.8021 12.2577L45.8831 21.1269L41.3171 23.7219L34.1839 19.6676V14.4789L42.0276 10.115C43.0774 9.53079 43.4478 8.21937 42.8543 7.18543C42.2608 6.15177 40.928 5.78716 39.8783 6.37163L34.1839 9.53996V2.14987C34.1839 0.962567 33.2063 0 31.9999 0C30.7934 0 29.8159 0.962567 29.8159 2.14987V9.53996L24.1212 6.37192C23.0708 5.78716 21.7383 6.15206 21.1451 7.18572C20.5517 8.21937 20.9218 9.53108 21.9719 10.1153L29.8159 14.4792V19.6684L22.683 23.7222L18.1164 21.1269L18.1973 12.258C18.2081 11.0707 17.2393 10.0995 16.0329 10.0889C16.0259 10.0889 16.0195 10.0889 16.0131 10.0889C14.8162 10.0889 13.8401 11.0386 13.8293 12.2196L13.7705 18.6574L7.27068 14.9631C6.22527 14.3691 4.88983 14.7217 4.28734 15.7499C3.68427 16.7781 4.04215 18.093 5.08668 18.6866L11.5883 22.3818L5.953 25.6511C4.91371 26.2539 4.56777 27.5719 5.18045 28.595C5.58755 29.2752 6.31583 29.6535 7.06392 29.6535C7.44074 29.6535 7.82279 29.5575 8.17077 29.3557L15.9338 24.8519L20.4987 27.4464V35.5545L15.9315 38.1504L8.17106 33.6457C7.13236 33.0426 5.79371 33.3829 5.18045 34.4056C4.56777 35.4284 4.91371 36.7464 5.95242 37.3495L11.5862 40.6193L5.08668 44.3134C4.04215 44.907 3.68427 46.2219 4.28734 47.2501C4.69211 47.9397 5.42593 48.3253 6.18072 48.3253C6.55112 48.3253 6.92706 48.2321 7.27068 48.0369L13.7705 44.3429L13.8293 50.7813C13.8401 51.962 14.8159 52.912 16.0131 52.912C16.0195 52.912 16.0264 52.912 16.0329 52.9117C17.239 52.9011 18.2081 51.9299 18.1973 50.7426L18.1161 41.8728L22.6827 39.2775L29.8159 43.3319V48.5216L21.9719 52.8856C20.9221 53.4698 20.5517 54.7812 21.1451 55.8151C21.5467 56.5146 22.2866 56.9076 23.0484 56.9076C23.4124 56.9076 23.7817 56.8178 24.1212 56.6289L29.8159 53.4609V60.8504C29.8159 62.0377 30.7934 63.0003 31.9999 63.0003C33.2063 63.0003 34.1839 62.0377 34.1839 60.8504V53.4609L39.8785 56.6289C40.2181 56.8178 40.5873 56.9076 40.9513 56.9076C41.7131 56.9076 42.453 56.5146 42.8546 55.8151C43.4481 54.7812 43.0779 53.4698 42.0279 52.8856L34.1842 48.5216V43.3321L41.3177 39.2775L45.8837 41.8722L45.8004 50.7417C45.7893 51.929 46.7581 52.9005 47.9643 52.9114C47.971 52.9117 47.978 52.9117 47.9847 52.9117C49.1815 52.9117 50.1573 51.962 50.1684 50.7816L50.2289 44.3417L56.7299 48.0366C57.0741 48.2321 57.4495 48.325 57.8199 48.325C58.5747 48.325 59.3088 47.9392 59.7133 47.2498C60.3161 46.2219 59.9579 44.907 58.9136 44.3134ZM24.8667 27.4461L32.0005 23.3914L39.1337 27.4461V35.5539L32.0005 39.6086L24.8667 35.5539V27.4461Z"
                          fill="#0D9AE1"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_30388_5797">
                          <rect width="64" height="63" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="about-us-box-left">
                    <div className="about-image-box">
                      <img src={item.image} alt="aboutImage" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="about-us-box-left">
                    <div className="about-image-box">
                      <img src={item.image} alt="aboutImage" />
                    </div>
                  </div>
                  <div className="about-us-box-right">
                    <h1>{item.title}</h1>
                    <p>{item.contentText}</p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
